var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotPatternHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 308 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 157.983,
    r: 2.648,
    transform: "rotate(-90 2.648 157.983)",
    fill: "#70C217"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 2.648 119.151)",
    fill: "#70C217"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 2.648 80.315)",
    fill: "#70C217"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 2.648 41.481)",
    fill: "#70C217"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.648,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 2.648 2.647)",
    fill: "#70C217"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 157.985,
    r: 2.648,
    transform: "rotate(-90 41.482 157.985)",
    fill: "#70C217"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 41.482 119.151)",
    fill: "#70C217"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 41.482 80.315)",
    fill: "#70C217"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 41.482 41.481)",
    fill: "#70C217"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.482,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 41.482 2.647)",
    fill: "#70C217"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 157.985,
    r: 2.648,
    transform: "rotate(-90 80.317 157.985)",
    fill: "#70C217"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 80.317 119.151)",
    fill: "#70C217"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 80.317 80.315)",
    fill: "#70C217"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 80.317 41.481)",
    fill: "#70C217"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.317,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 80.317 2.647)",
    fill: "#70C217"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 157.985,
    r: 2.648,
    transform: "rotate(-90 119.151 157.985)",
    fill: "#70C217"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 119.151 119.151)",
    fill: "#70C217"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 119.151 80.315)",
    fill: "#70C217"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 119.151 41.481)",
    fill: "#70C217"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.151,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 119.151 2.647)",
    fill: "#70C217"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 157.985,
    r: 2.648,
    transform: "rotate(-90 157.986 157.985)",
    fill: "#70C217"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 157.986 119.151)",
    fill: "#70C217"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 157.986 80.315)",
    fill: "#70C217"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 157.986 41.481)",
    fill: "#70C217"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.986,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 157.986 2.647)",
    fill: "#70C217"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.82,
    cy: 157.985,
    r: 2.648,
    transform: "rotate(-90 196.82 157.985)",
    fill: "#70C217"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.82,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 196.82 119.151)",
    fill: "#70C217"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.82,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 196.82 80.315)",
    fill: "#70C217"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.82,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 196.82 41.481)",
    fill: "#70C217"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.82,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 196.82 2.647)",
    fill: "#70C217"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.655,
    cy: 157.985,
    r: 2.648,
    transform: "rotate(-90 235.655 157.985)",
    fill: "#70C217"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.655,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 235.655 119.151)",
    fill: "#70C217"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.655,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 235.655 80.315)",
    fill: "#70C217"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.655,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 235.655 41.481)",
    fill: "#70C217"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.655,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 235.655 2.647)",
    fill: "#70C217"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.489,
    cy: 157.985,
    r: 2.648,
    transform: "rotate(-90 274.489 157.985)",
    fill: "#70C217"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.489,
    cy: 119.151,
    r: 2.648,
    transform: "rotate(-90 274.489 119.151)",
    fill: "#70C217"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.489,
    cy: 80.315,
    r: 2.648,
    transform: "rotate(-90 274.489 80.315)",
    fill: "#70C217"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.489,
    cy: 41.481,
    r: 2.648,
    transform: "rotate(-90 274.489 41.481)",
    fill: "#70C217"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.489,
    cy: 2.647,
    r: 2.648,
    transform: "rotate(-90 274.489 2.647)",
    fill: "#70C217"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPatternHorizontal);
export default __webpack_public_path__ + "static/media/dot-pattern-horizontal.b0a89e21.svg";
export { ForwardRef as ReactComponent };